import { config } from "../Constants";

export const openOAuthPopup = (loginSuccessCallback, redirectPath) => {
    if (redirectPath) {
        localStorage.setItem('redirectAfterLogin', redirectPath);
    }

    const width = 500;
    const height = 650;
    const left = window.screenX + (window.outerWidth - width) / 2;
    const top = window.screenY + (window.outerHeight - height) / 2.5;

    const currentOrigin = window.location.origin;
    const redirectUri = `${currentOrigin}/oauth2/redirect`;

    const URL = config.url;
    const url = `${URL}/oauth2/authorize/google?redirect_uri=${encodeURIComponent(redirectUri)}`;

    const popup = window.open(
        url,
        'Login with Google',
        `width=${width},height=${height},left=${left},top=${top},toolbar=0,scrollbars=1,status=1,resizable=1,location=1,menuBar=0`
    );

    if (!popup) {
        console.error("Popup blocked. Please allow popups for this site.");
        alert("Please allow popups to continue with Google login.");
        return;
    }

    if (popup && popup.focus) {
        popup.focus();
    }
    
    const allowedOrigins = [
        'http://dev.stockmaid.com:3000',
        'http://dev.stockmaid.com:3001',
        'http://dev.stockmaid.com:8080',
        'http://dev.stockmaid.com:8081',
        'https://stockmaid.com',
        'https://www.stockmaid.com'
    ];
    
    const handleMessage = (event) => {
        
        if (!allowedOrigins.some(origin => event.origin.startsWith(origin))) {
            console.warn("Received message from unauthorized origin:", event.origin);
            return;
        }

        if (event.data && event.data.type === 'oauth2_success') {
            const token = event.data.token;
            
            if (loginSuccessCallback && token) {
                loginSuccessCallback(token).then(success => {
                    if (success) {
                        const savedRedirect = localStorage.getItem('redirectAfterLogin');
                        if (savedRedirect) {
                            localStorage.removeItem('redirectAfterLogin');
                            window.location.href = savedRedirect;
                        } else {
                            window.location.reload();
                        }
                    }
                });
            }
            
            window.removeEventListener('message', handleMessage);
        }
        
        if (event.data && event.data.type === 'oauth2_error') {
            console.error('Authentication error:', event.data.error);
            
            alert(`Authentication failed: ${event.data.message || 'Unknown error'}`);
            
            window.removeEventListener('message', handleMessage);
        }
    };

    window.addEventListener('message', handleMessage);
    
    setTimeout(() => {
        if (popup && !popup.closed) {
            popup.close();
            console.warn("Login popup timed out");
            window.removeEventListener('message', handleMessage);
        }
    }, 5 * 60 * 1000);
    
    return () => {
        window.removeEventListener('message', handleMessage);
        if (popup && !popup.closed) {
            popup.close();
        }
    };
};